import React from 'react'
import splitter from "../assets/portfolio/splitter.png"
import tindog from "../assets/portfolio/tindog.jpg"
import studyNotion from "../assets/portfolio/studyNotion.png"

import drumkit from '../assets/portfolio/drumkit.png'
import simon from '../assets/portfolio/simon.png'
import heartWiseConnect from "../assets/portfolio/heartWiseConnect.png"

const Portfolio = () => {

    function clickHandler(id) {
        const url = portfolios[id - 1].link;
        console.log(url);
        window.open(url);
    }
    function clickHandler1(id) {
        const url = portfolios[id - 1].git;
        console.log(url);
        window.open(url);
    }
    // Can add a link to each part of the array to go to onclick
    const portfolios = [
        {
            id: 1,
            src: studyNotion,
            link: 'https://studynotion-dn.vercel.app/',
            git: 'https://github.com/shubham7546/Study-Notion.git',
        },
        {
            id: 2,
            src: heartWiseConnect,
            link: 'https://heart-wise-connection-gegl.vercel.app/',
            git: 'https://github.com/shubham7546/HeartWiseConnection.git',
        },
        {
            id: 3,
            src: splitter,
            link: 'https://calculator-9ed94.web.app/',
            git: "https://github.com/shubham7546/splits-up/tree/main"


        },
        {
            id: 4,
            src: tindog,
            link: 'https://tindog7546.web.app/',
            git: 'https://github.com/shubham7546/TinDog/tree/main'
        },
        {
            id: 5,
            src: drumkit,
            link: 'https://drumkit7546.web.app/',
            git: 'https://github.com/shubham7546/drumKit'
        },
        {
            id: 6,
            src: simon,
            link: 'https://simon7546.web.app/',
            git: 'https://github.com/shubham7546/simon-game',
        },



    ]

    return (
        <div name='portfolio' className='w-full text-white bg-gradient-to-b from-black to-gray-800 min-h-screen'>
            <div className='flex flex-col justify-center w-full h-full max-w-screen-lg p-4 pb-16 mx-auto'>
                <div>
                    <p className='inline text-4xl font-bold border-b-4 border-gray-500'>Portfolio</p>
                    <p className='py-6 text-2xl text-gray-400'>Check out some of my work right here</p>
                </div>
                <div className='grid gap-8 px-12 sm:grid-cols-2 md:grid-cols-3 sm:px-0'>
                    {
                        portfolios.map(({ id, src }) => (
                            <div key={id} className='rounded-lg shadow-md shadow-gray-600'>
                                <img src={src} alt="" className='duration-200 rounded-md hover:scale-105' />
                                <div className='flex items-center justify-center'>
                                    <button onClick={() => clickHandler(id)} className='w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105'>
                                        Demo
                                    </button>
                                    <button onClick={() => clickHandler1(id)} className='w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105'>
                                        Code
                                    </button>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default Portfolio